import React, { useState, type InputHTMLAttributes } from "react";

import { RiLockLine } from "react-icons/ri";
import * as Styles from "./textInput.styles";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  onChange?: (val: any) => void;
  value?: any;
  type?: "text" | "email" | "password";
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  mandatory?: boolean;
  lockIcon?: boolean;
  borderColor?: string;
  style?: any;
  multiline?: boolean;
  isError?: boolean;
  focus?: boolean;
  matchDisabled?: boolean;
}

export const TextInput = ({
  onChange,
  value,
  type,
  placeholder,
  disabled,
  maxLength,
  mandatory,
  lockIcon,
  borderColor,
  style,
  multiline,
  isError,
  focus,
  matchDisabled,
  ...rest
}: Props) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onHandleFocus = (val: boolean) => {
    if (focus) setIsFocused(val);
  };

  return (
    <Styles.ContainerInput
      disabled={disabled}
      matchDisabled={matchDisabled}
      isFocused={isFocused}
      borderColor={borderColor ?? (isError ? "red" : "#C4C4C4")}
      style={style}
      multiline={multiline}
    >
      {multiline ? (
        <Styles.TextArea
          maxLength={maxLength}
          placeholder={placeholder}
          onFocus={() => {
            onHandleFocus(true);
          }}
          onBlur={() => {
            onHandleFocus(false);
          }}
          onChange={(ev) => {
            onChange?.(ev.target.value);
          }}
          disabled={disabled}
          required={mandatory}
          style={{ height: 80, resize: "none" }}
          value={value}
        />
      ) : (
        <Styles.Input
          type={type ?? "text"}
          maxLength={maxLength}
          placeholder={placeholder}
          onFocus={() => {
            onHandleFocus(true);
          }}
          onBlur={() => {
            onHandleFocus(false);
          }}
          onChange={(ev) => {
            onChange?.(ev.target.value);
          }}
          disabled={disabled}
          required={mandatory}
          value={value}
          {...rest}
        />
      )}
      {lockIcon && (
        <div style={{ display: "flex", alignItems: "center", paddingRight: 6 }}>
          <RiLockLine size={20} />
        </div>
      )}
    </Styles.ContainerInput>
  );
};

TextInput.defaultProps = {
  placeholder: "--",
  disabled: false,
  maxLength: 10000,
  mandatory: false,
};
